
export default {
    install(Vue) {
        Vue.prototype.$setHeaderImage = function (image) {
            if (image) {
                return image;
            }
            return require('@/assets/images/head2.jpg');
        }

        Vue.prototype.$setTooltipTitle = function (image){

            let data= sessionStorage.lang === "hu" ? {
                "sg_icon_korlatozott_ideig.png": "Korlátozott ideig",
                "sg_icon_quality.png": "High quality",
                "sg_icon_csak_nalunk.png": "Csak nálunk",
                "sg_icon_donteshozok.png": "Döntéshozók figyelmébe",
                "sg_icon_legjobb_ar.png": "Legjobb ár/érték arány",
                "sg_icon_uj.png": "Újdonság",
                "sg_icon_biztonsag.png": "Biztonság",
                "sg_icon_kedvelt.png": "Kedvelt szolgáltatás",
                "sg_icon_ajanljuk.png": "Ezt ajánljuk",
            } : {
                "sg_icon_korlatozott_ideig.png": "For a limited time",
                "sg_icon_quality.png": "High quality",
                "sg_icon_csak_nalunk.png": "Only at us",
                "sg_icon_donteshozok.png": "for the attention of decision-makers",
                "sg_icon_legjobb_ar.png": "Best price/value ratio",
                "sg_icon_uj.png": "New",
                "sg_icon_biztonsag.png": "Security",
                "sg_icon_kedvelt.png": "Favourite service",
                "sg_icon_ajanljuk.png": "Recommended",
            };

            return data[image];
        }
    }
};
